import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import UserDashboard from './pages/UserDashboard';
import MarketingLandingPage from './pages/MarketingLandingPage';
import PantryPage from './pages/PantryPage';
import GenerateRecipePage from './pages/GenerateRecipePage';
import CookbookPage from './pages/CookbookPage';
import SettingsPage from './pages/SettingsPage';
import AuthCallback from './pages/AuthCallback';
import Layout from './components/Layout';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { supabase } from './utils/supabase';
import './App.css';

// SINGLE auth system for the entire app
const AppWithAuth = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Listen for auth changes (ONE listener for entire app)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Home route */}
      <Route 
        path="/" 
        element={
          session ? (
            <Layout><UserDashboard session={session}/></Layout>
          ) : (
            <MarketingLandingPage />
          )
        } 
      />
      
      {/* Protected routes */}
      {session ? (
        <>
          <Route path="/pantry" element={<Layout><PantryPage session={session} /></Layout>} />
          <Route path="/generate-recipe" element={<Layout><GenerateRecipePage session={session} /></Layout>} />
          <Route path="/cookbook" element={<Layout><CookbookPage session={session} /></Layout>} />
          <Route path="/cookbook/:recipeId" element={<Layout><CookbookPage session={session} /></Layout>} />
          <Route path="/settings" element={<Layout><SettingsPage session={session} /></Layout>} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
    </Routes>
  );
};

function App() {
  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <AppWithAuth />
      </BrowserRouter>
    </ThemeContextProvider>
  );
}

export default App;